import axios from 'axios'
import reqBase from '@/_helpers/requests/reqBase'

const requestNotif = axios.create()

requestNotif.interceptors.request.use(
    config => reqBase.interceptorsRequest(config))

requestNotif.interceptors.response.use(function (response) {
    
    reqBase.interceptorsResponse(response);
     
	return response;
}, function (error) {
    let _response = error.response;
    _response['type'] = 'Error';
    reqBase.interceptorsResponse(_response);

    return Promise.reject(error);
});
  
export default requestNotif